import {
  DashboardReportMarginBoxes,
  MarginBox,
  PageLayout,
} from "api/model/dashboard/DashboardReportOptions";
import { T } from "services/lang/LanguageService";
import React from "react";
import { Leaves, setObjAttribute } from "utils/utils";
import { Input } from "../InputCategories";

type PageLayoutKey = Leaves<PageLayout>;

const PageLayoutSubForm = (props: {
  marginBoxes?: DashboardReportMarginBoxes;
  pageLayout: PageLayout;
  onChange: (o: PageLayout) => void;
  onChangeMarginBoxes: (key: keyof DashboardReportMarginBoxes, o: MarginBox) => void;
}) => {
  const onChangePageLayout = (prop: PageLayoutKey, value: any) => {
    const newPageLayout = { ...props.pageLayout };
    setObjAttribute(newPageLayout, prop, value);
    props.onChange(newPageLayout);
  };

  const onChangeMarginBox = (key: keyof DashboardReportMarginBoxes, prop: string, value: any) => {
    const newMarginBox: MarginBox = {
      content: props.marginBoxes?.[key]?.content ?? "",
      hideBorder: props.marginBoxes?.[key]?.hideBorder,
      variables: props.marginBoxes?.[key]?.variables ?? {},
    };
    setObjAttribute(newMarginBox, prop, value);
    props.onChangeMarginBoxes(key, newMarginBox);
  };

  return (
    <>
      <h5 className="mb-5">{T("word.page-layout")}</h5>
      <div className="grid">
        <span className="p-float-label col-12 md:col-4">
          <Input.List
            id="input-page-layout-size"
            label={T("label.page-format-size")}
            property="format.pageSize"
            sourceObj={props.pageLayout}
            onChange={onChangePageLayout}
            options={[
              { label: "A2", value: "A2" },
              { label: "A3", value: "A3" },
              { label: "A4", value: "A4" },
            ]}
            editable
          />
        </span>

        <span className="p-float-label col-12 md:col-4">
          <Input.List
            options={[
              { label: "PORTRAIT", value: "PORTRAIT" },
              { label: "LANDSCAPE", value: "LANDSCAPE" },
            ]}
            id="input-page-layout-orientation"
            label={T("label.page-orentation")}
            property="format.orientation"
            sourceObj={props.pageLayout}
            onChange={onChangePageLayout}
          />
        </span>

        <span className="col-12 md:col-4">
          <Input.Color
            id="bg-color"
            label={T("word.background-color")}
            property="bgColor"
            sourceObj={props.pageLayout}
            onChange={onChangePageLayout}
          />
        </span>
      </div>

      <h5 className="mb-5">{T("label.margin-boxes")}</h5>
      <div className="grid">
        <span className="col-12 md:col-3">
          <span className="p-float-label">
            <Input.Text
              id="input-page-layout-margin-boxes-top"
              label={T("word.top")}
              property="margins.top"
              sourceObj={props.pageLayout}
              onChange={onChangePageLayout}
            />
          </span>

          <div className="my-3">
            <Input.Boolean
              id="input-page-layout-margin-boxes-top-auto"
              label={T("action.hide-border")}
              property="hideBorder"
              sourceObj={props.marginBoxes?.topCenter}
              onChange={(prop, value) => onChangeMarginBox("topCenter", prop, value)}
            />
          </div>
        </span>

        <span className="col-12 md:col-3">
          <span className="p-float-label">
            <Input.Text
              id="input-page-layout-margin-boxes-bottom"
              label={T("word.bottom")}
              property="margins.bottom"
              sourceObj={props.pageLayout}
              onChange={onChangePageLayout}
            />
          </span>

          <div className="my-3">
            <Input.Boolean
              id="input-page-layout-margin-boxes-bottom-auto"
              label={T("action.hide-border")}
              property="hideBorder"
              sourceObj={props.marginBoxes?.bottomCenter}
              onChange={(prop, value) => onChangeMarginBox("bottomCenter", prop, value)}
            />
          </div>
        </span>

        <span className="p-float-label col-12 md:col-3">
          <Input.Text
            id="input-page-layout-margin-boxes-left"
            label={T("word.left")}
            property="margins.left"
            sourceObj={props.pageLayout}
            onChange={onChangePageLayout}
          />
        </span>

        <span className="p-float-label col-12 md:col-3">
          <Input.Text
            id="input-page-layout-margin-boxes-right"
            label={T("word.right")}
            property="margins.right"
            sourceObj={props.pageLayout}
            onChange={onChangePageLayout}
          />
        </span>
      </div>
    </>
  );
};

export default PageLayoutSubForm;
